<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/5ImfH2/tc-custom/9781612437415.jpg?1726444214910" alt="This image is the cover for the book Baking Magic with Aquafaba"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Baking Magic with Aquafaba
      </h1>
      <p class="bookDescription body article font2">
        <p>Delicious egg-free baked goods using aquafaba.<br/><br/> Move over tofu, there’s a miraculous new egg replacement in town! With baking properties so amazing it can create fluffy quiche and light meringue, aquafaba is the breakthrough ingredient that will revolutionize your vegan baking.<br/><br/> Baking Magic with Aquafaba offers up recipes for creamy sweet treats and rich savory dishes, such as:<br/><br/> • Key Lime Mousse<br/> • Chocolate Pirouette Cookies<br/> • Lemon Meringue Pie<br/> • Birthday Cake Waffles<br/> • Pistachio Macarons<br/> • Sponge Cake<br/> • Rocky Road Ice Cream<br/> • Cranberry Orange Scones<br/> • Pesto Flatbread<br/> • Baked “Mozzarella” Sticks<br/> • Hollandaise Sauce• Garlic Aioli<br/><br/> This cruelty-free ingredient is as versatile as it is tasty. It can be whipped into cakes, pie fillings, delicious icings and used as a fat substitute for butters, aiolis and cheeses, without sacrificing texture or flavor. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kelsey Kinser
      </h2>
      
      <p class="authorDescription body article">Kelsey Kinser&#160;is a professionally trained chef and recipe developer working in New York City.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Ulysses Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5c6450ad